import { Flex, Image } from '@chakra-ui/react';
import Link from 'next/link';

import logo from '$assets/logo.svg';

interface LogoProps {
  scrolled?: boolean;
}

export function Logo({ scrolled = false }: LogoProps) {
  return (
    <Link href="/" aria-label="Ir para o início">
      <Flex
        align="center"
        gap="10px"
        color="text.primary"
        transition="color 0.2s ease"
        _hover={{ color: 'accent.500' }}
      >
        <Image src={logo.src} alt="Logo" w="100px" />
      </Flex>
    </Link>
  );
}
